import React from 'react';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicFileUploadProps } from '../../../types/public-props';
import { Field } from '../../../headless/field';

interface DescritionFileUploadProps {
  className?: string;
}

export const Description = React.forwardRef<
  HTMLDivElement,
  DescritionFileUploadProps
>((props, ref) => {
  const { className } = props;

  const { description } = useFieldProps<PublicFileUploadProps>();

  return (
    <Field.Description
      ref={ref}
      className={className}
      description={description}
    />
  );
});

Description.displayName = 'FileUpload.Description';
